<div class="p-4 space-y-4">
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Door Style</label>
    <select
      class="border border-stone-400 rounded p-2 w-full mb-3 bg-stone-200 text-black"
      [value]="selected().door.code"
      (change)="setDoor($event)"
    >
      @for (door of doors(); track door.code) {
        <option [value]="door.code">
          {{ door.name }}
        </option>
      }
    </select>
  </div>

  <div>
    <label class="block text-sm font-medium text-gray-700 mb-1">Door Color</label>
    <select
      class="border border-stone-400 rounded p-2 w-full mb-3 bg-stone-200 text-black"
      [value]="selected().doorColor?.code ?? ''"
      (change)="setColor($event)"
    >
      @for (color of colors(); track color.code) {
        <option [value]="color.code">
          {{ color.color }}
        </option>
      }
    </select>
  </div>
</div>
